import React, { useState } from "react";
import { Button, Icon, SheetContainer, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";
import styles from "./FlightCardGeniusHighlightBottomSheetWrapper.module.css";
const FlightCardGeniusHighlightBottomSheetWrapper = ({ infoTooltip }) => {
    const i18n = useI18n();
    const [isBottomSheetActive, setBottomSheetActive] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { variant: "tertiary", className: styles.geniusHighlightBottomSheetButton, attributes: {
                "aria-label": infoTooltip.ariaLabel,
                onClick: (event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    setBottomSheetActive(true);
                }
            } },
            React.createElement(Icon, { size: "medium", svg: InfoSignIcon })),
        React.createElement(SheetContainer, { active: isBottomSheetActive, onCloseTrigger: () => setBottomSheetActive(false), closeAriaLabel: i18n.trans(t("a11y_flights_sr_genius_pinned_deal_close_popup")), position: "bottom", title: infoTooltip.title ?? "" },
            React.createElement(Text, null, infoTooltip.content))));
};
export default FlightCardGeniusHighlightBottomSheetWrapper;
